//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PageLimiter from '../components/PageLimiter.vue';
import FooterSubscribe from '../components/FooterSubscribe.vue';
import FooterSocial from '../components/FooterSocial.vue';

export default {
	name: 'PageFooter',

	components: {
		PageLimiter: PageLimiter,
		FooterSubscribe: FooterSubscribe,
		FooterSocial: FooterSocial
	},

	computed: {
		mobile: function mobile() {
			return this.$route.query.mobile;
		},
		settings: function settings() {
			return this.$store.state.settings || {};
		},
		lang: function lang() {
			return this.settings.lang;
		},
		locale: function locale() {
			var target = this.lang === 'ru' ? 'en' : 'ru';
			return this.settings.locales[target];
		},
		nav: function nav() {
			return this.settings.globalNav;
		},
		copy: function copy() {
			return '&copy; ' + new Date().getFullYear() + ', ' + this.$lang('copyright', null, this.lang);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageFooter.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageFooter.vue
// module chunks = 5